import { Component } from 'react';
import { Box, Chip, Stack } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookBookmark, faHome, faPersonDress } from '@fortawesome/free-solid-svg-icons';

export default class Navbar extends Component {
  getItems() {
    return [
      {
        icon: faHome,
        link: '/',
        text: 'Homepage',
      },
      {
        icon: faBookBookmark,
        link: '/projects',
        text: 'My Projects',
      },
      {
        icon: faPersonDress,
        link: '/about',
        text: 'About me',
      },
    ];
  }

  render() {
    let items = this.getItems();
    let navItems = [];
    items.forEach((item, index) => {
      let label = <Stack direction='row' spacing={2}>
        <FontAwesomeIcon icon={item.icon} className='icon' />
        <Box className='text'>{item.text}</Box>
      </Stack>;
      navItems.push(
        <Box key={index}>
          <Chip className='nav' label={label}
            component='a' href={item.link} clickable />
        </Box>
      );
    });


    return (
      <Stack className='navbar'>
        {navItems}
      </Stack>
    );
  }
}
